<template>
    <b-card no-body>
      <validation-observer v-slot="{ handleSubmit }" ref="VForm">
        <b-form @submit.prevent="handleSubmit($parent.doSubmitCRUD('VForm', $refs))">
          <b-card-header>
            <b-row>
              <b-col lg="8">
                <h5 class="card-title">{{ $parent.isAdd?'Add':'Edit' }} {{ $parent.pageTitle }}</h5>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col lg=4>
                <b-form-group>
                  <template #label>Agenda <strong class="text-danger">*</strong></template>
                  <b-form-input v-model="row.mm_title" placeholder="e.g. Ureq bersama client"></b-form-input>
                  <VValidate name="Agenda" v-model="row.mm_title" rules="required|max:60" />
                </b-form-group>
              </b-col>
              <b-col lg=6>
                <b-form-group>
                  <template #label>Partisipan <strong class="text-danger">*</strong></template>
                  <b-form-tags tag-variant="success" v-model="row.mm_participants" remove-on-delete></b-form-tags>
                  <VValidate name="Partisipan" v-model="row.mm_participants" rules="required" />
                </b-form-group>
              </b-col>
              <b-col lg=4>
                <b-form-group>
                  <label>Tanggal <span class="text-danger mr5">*</span></label>
                  <date-picker type="date" value-type="format" format="YYYY-MM-DD"  prefix-class="crm" v-model="row.mm_date" :disabled-date="$parent.beforeToday" />
                  <VValidate name="Tanggal" v-model="row.mm_date" rules="required" />
                </b-form-group>
              </b-col>
              <b-col lg=2>
                <b-form-group>
                  <label>Jam Mulai <span class="text-danger mr5">*</span></label>
                  <date-picker type="time" :show-second="false" value-type="format" title-format="HH:mm" format="HH:mm:ss" minute-step="30"  prefix-class="crm" v-model="row.mm_start_time" :disabled-date="$parent.beforeToday" />
                  <VValidate name="Jam Mulai" v-model="row.mm_start_time" rules="required" />
                </b-form-group>
              </b-col>
              <b-col lg=2>
                <b-form-group>
                  <label>Jam Selesai</label>
                  <date-picker type="time" :show-second="false" value-type="format" title-format="HH:mm" format="HH:mm:ss" minute-step="30"  prefix-class="crm" v-model="row.mm_end_time" :disabled-date="$parent.beforeToday" />
                  <VValidate name="Jam Mulai" v-model="row.mm_end_time" rules="" />
                </b-form-group>
              </b-col>
              <b-col lg=6>
                <b-form-group>
                  <label>Catatan</label>
                  <b-form-textarea v-model="row.mm_note"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
          <b-card-footer>
            <b-row>
              <b-col lg="12" class="text-right">
                <button @click="$router.back()" type="button" class="btn btn-rounded btn-default mr-3">Cancel</button>
                <b-button type="submit" variant="info" class="btn-rounded">Submit</b-button>
              </b-col>
            </b-row>
          </b-card-footer>
        </b-form>
      </validation-observer>
    </b-card>
</template>
<script>
 export default {
    props: {
      row: Object,
      mrVehicleCategory: Array,
      mrValidation: Object,
      Config: Object,
    },
    data(){
      return {
        mrType: [
          {label: "Staff", value: "S"},
          {label: "Partner", value: "P"}
        ]
      }
    },
    methods: {
      doSubmitForm() {
        this.$emit('click:doSubmit', 'VForm', this.$refs)
      },
    }
 }
</script>
